/**
 * 打单余额在线充值接口封装（主站 wapi/recharge）
 * 四种支付：信用卡 Stripe / 微信(HantePay) / 支付宝(HantePay) / PayPal，充值到打单余额 fa_user.money。
 * 说明：与后端 application/wapi/controller/Recharge.php 对应；user_code 取自登录缓存 userInfo1，
 *      client 固定 pc，lang 跟随站点语言；统一 JSON body，返回 { code, msg, data }，code==1 成功。
 */
import { postj } from '@/utils/request1';

// 当前登录用户编码（打单主库 fa_user.user_code）
function userCode() {
  try {
    return JSON.parse(window.localStorage.getItem('userInfo1')).user_code;
  } catch (e) {
    return '';
  }
}

// 站点语言（zh / en）
function lang() {
  return window.localStorage.getItem('lhkdLang') === 'en' ? 'en' : 'zh';
}

// ===== 信用卡 Stripe =====
export function rechargeStripeCreate(amount) {
  return postj('recharge/stripeCreate', { user_code: userCode(), amount, client: 'pc', lang: lang() });
}
export function rechargeStripeConfirm(rechargeSn) {
  return postj('recharge/stripeConfirm', { user_code: userCode(), recharge_sn: rechargeSn, lang: lang() });
}

// ===== PayPal =====
export function rechargePaypalConfig() {
  return postj('recharge/paypalConfig', { lang: lang() });
}
export function rechargePaypalCreate(amount) {
  return postj('recharge/paypalCreate', { user_code: userCode(), amount, client: 'pc', lang: lang() });
}
export function rechargePaypalCapture(rechargeSn, paypalOrderId) {
  return postj('recharge/paypalCapture', {
    user_code: userCode(),
    recharge_sn: rechargeSn,
    paypal_order_id: paypalOrderId,
    lang: lang(),
  });
}

// ===== 微信 / 支付宝（HantePay 扫码） =====
export function rechargeHantepayCreate(amount, method) {
  return postj('recharge/hantepayCreate', { user_code: userCode(), amount, method, client: 'pc', lang: lang() });
}
export function rechargeHantepayQuery(rechargeSn) {
  return postj('recharge/hantepayQuery', { recharge_sn: rechargeSn, lang: lang() });
}
